import { Button } from "@mui/material"
import { useTranslations } from "next-intl"

export const CTLoginFlowBackButton = ({ onClick }: { onClick: () => void }) => {
    const t = useTranslations('otpModal')
    return (
        <Button fullWidth sx={{ fontWeight: 600 }} onClick={onClick}>{t('goBack')}</Button>
    )
}
